import React, { useEffect, useState } from "react";

const OpenRoleList = ({ interests, onTopMatches }) => {
  const [openRoles, setOpenRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchOpenPositions = async () => {
      try {
        const interestParam = encodeURIComponent(interests || "");
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/projects/admin/open-positions?interests=${interestParam}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();
        if (!res.ok) throw new Error(data.message);

        setOpenRoles(data.openRoles || []);

        // ✅ Only top 3 passed to parent for preview
        if (onTopMatches) {
          onTopMatches(data.openRoles || []);
        }

        setLoading(false);
      } catch (err) {
        console.error("❌ Fetch error:", err.message);
      }
    };

    fetchOpenPositions();
  }, [interests, token, onTopMatches]); // <- include onTopMatches as dep

  const grouped = openRoles.reduce((acc, role) => {
    const key = role.projectId;
    if (!acc[key]) {
      acc[key] = {
        projectId: role.projectId,
        projectTitle: role.projectTitle,
        image: role.image,
        oneLiner: role.projectOneLiner,
        roles: [],
      };
    }
    acc[key].roles.push({
      roleTitle: role.roleTitle,
      description: role.description,
      matchScore: role.matchScore,
    });
    return acc;
  }, {});
  const projectList = Object.values(grouped);

  if (loading) return <p className="text-xs text-gray-400">Loading roles...</p>;
  if (projectList.length === 0)
    return <p className="text-xs text-gray-400">No matching roles found.</p>;

  return (
    <div className="space-y-4 mb-4">
      {projectList.map((project, index) => (
        <div
          key={index}
          className="border rounded-lg overflow-hidden shadow-sm bg-gray-50"
        >
          {project.image && (
            <img
              src={project.image}
              alt={project.projectTitle}
              className="w-full h-32 object-cover"
            />
          )}
          <div className="p-3">
            <h4 className="text-sm font-bold text-blue-700 mb-1">
              {project.projectTitle}
            </h4>
            <p className="text-xs italic text-gray-600 mb-2">{project.oneLiner}</p>
            <ul className="space-y-2">
              {project.roles.map((role, rIndex) => (
                <li key={rIndex} className="bg-white border p-2 rounded">
                  <div className="flex justify-between items-center mb-1">
                    <p className="font-semibold text-gray-800">{role.roleTitle}</p>
                    {role.matchScore !== undefined && (
                      <span className="text-xs text-green-600 font-medium">
                        {role.matchScore}% match
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 italic">{role.description}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OpenRoleList;
